<template>
	<main class="common-main-container">
		<div
			style="
				position: fixed;
				top: 70px;
				z-index: 10001;
				backdrop-filter: blur(2px);
			"
			v-if="LoaderStatus"
		>
			<Spinner :statusText="ideCurrentStatus.message" />
		</div>
		<header>
			<section class="d-flex align-items-center">
				<img
					src="../../assets/icons/Reports/bckarrow.svg"
					class="mr-3 pointer"
					alt=""
					@click="$router.go(-1)"
				/>
				<h1>
					View Code Sandbox
				</h1>
			</section>
		</header>
		<iframe
			class="iframe-style bg-ide-black"
			:src="ide && ide.sandbox_url"
			frameborder="0"
		></iframe>
		<div v-if="ide && ide.show_actions" class="save-button">
			<img src="../../assets//common-icons/dragIndicator.svg" alt="" />
			<img
				@click="$bvModal.show('previewModal')"
				v-b-tooltip.hover.left="{ variant: 'secondary' }"
				title="Preview Links"
				src="../../assets/common-icons/preview-links.svg"
				alt="Preview Links"
				class="pointer"
			/>
		</div>
		<PreviewLinksModal :previewLinks="previewLinks" />
	</main>
</template>
<script>
import {
	deleteCadidateIde,
	extendCandidateIde,
	getPreviewLink,
	viewIde,
} from "../../utils/apiFunctions";
import PreviewLinksModal from "./modals/PreviewLinksModal.vue";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import errorToast from "../mixin/toast";
import successToast from "../mixin/toast";
import pollSandbox from "./mixins/pollSandbox";

export default {
	name: "ViewCandidateSandbox",
	mixins: [errorToast, successToast, pollSandbox],
	data() {
		return {
			ide: undefined,
			LoaderStatus: true,
			showPreviewLinks: false,
			previewLinks: [],
			getPreviewLinkInterval: null,
			ideCurrentStatus: {
				message: "Loading Sandbox...",
				status: "loading",
			},
		};
	},
	components: {
		Spinner,
		PreviewLinksModal,
	},
	created() {
		this.getIdes();
	},
	async beforeRouteLeave(to, from, next) {
		try {
			if (this.ide.show_actions) {
				this.ideCurrentStatus = {
					message: "Deleting Sandbox...",
					status: "loading",
				};
				this.LoaderStatus = true;
				clearInterval(this.getPreviewLinkInterval);
				clearInterval(this.extendCandidateIdeInterval);
				await deleteCadidateIde(this.$route.params.testID, this.$route.params);
			}
		} finally {
			next();
		}
	},
	methods: {
		async getIdes() {
			try {
				this.LoaderStatus = true;
				const response = await viewIde(
					this.$route.params.testID,
					this.$route.params
				);
				if (response.status === 202) {
					const result = await this.pollSandbox(
						response.data.data.sandbox_job_id
					);
					if (!result.success) {
						throw new Error("Sandbox creation failed");
					}
					this.ide = result;
				} else if (response.status === 200) {
					this.ide = response.data.data;
				} else {
					throw new Error();
				}
				this.LoaderStatus = false;
				if (this.ide.show_actions) {
					this.getPreviewLinkInterval = setInterval(async () => {
						try {
							const res = await getPreviewLink(this.ide.sandbox_id);
							this.previewLinks = res.data.data.previewLinks;
						} catch (error) {
							console.log(error);
						}
					}, 2000);
					extendCandidateIde(this.$route.params.testID, this.ide.sandbox_id);
					this.extendCandidateIdeInterval = setInterval(() => {
						extendCandidateIde(this.$route.params.testID, this.ide.sandbox_id);
					}, 60000);
				}
			} catch (error) {
				this.errorToast("Unable to load the project. please refresh the page.");
				this.LoaderStatus = false;
			}
		},
	},
};
</script>
<style scoped>
.iframe-style {
	height: 80vh;
	width: -webkit-fill-available;
	margin-top: 10px;
}

.save-button {
	padding: 10px;
	position: absolute;
	top: 139px;
	right: 20px;
	background: rgba(249, 250, 251, 0.16);
	display: flex;
	flex-direction: column;
	border-radius: 10px 0 0 10px;
}
</style>
